import { Box, Container, Typography } from "@mui/material";
import React from "react";
import MultipleCodeEditor from "../../../shared/MultipleCodeEditor";

const PageClasses = ({ pageClass, handlePageClass, language }) => {
  return (
    <Container
      maxWidth="xl"
      sx={{
        height: "100%",
        py: { xs: 2, md: 3 },
        px: { xs: 1, sm: 2, md: 3 },
      }}
    >
      {/* Page Header */}
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontSize: { xs: "20px", md: "24px" },
          fontWeight: 600,
          fontFamily: "Manrope",
          color: "#1a1a1a",
          mb: 2,
        }}
      >
        Page Classes
      </Typography>

      {/* Code Editor Section */}
      <Box
        sx={{
          bgcolor: "#FFFFFF",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
          minHeight: "500px",
        }}
      >
        {pageClass.length > 0 ? (
          <MultipleCodeEditor
            editorsData={pageClass}
            setEditorsData={handlePageClass}
            language={language}
          />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              color: "#666",
            }}
          >
            <Typography variant="body1">
              No page class data available. Please generate page classes first.
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default PageClasses;
